import { IStore } from '../utils/store';
import { IOfflineStorage } from '../offline-storage';
import { parseProp } from '../utils/parseProp';
import { FeedbackState } from '../types/FeedbackState';
import { FEEDBACK_STATE, FEEDBACK_VISIT_THRESHOLD } from '../components/constants';
import { isFeedbackState } from '../utils/isFeedbackState';

export async function handleFeedbackCheck(
  { state }: IStore,
  storage: IOfflineStorage,
  currentTimestamp: number = Math.floor(Date.now() / 1000),
  limit: number = FEEDBACK_VISIT_THRESHOLD,
): Promise<void> {
  const feedbackRequestTime = state.config.lastFeedbackTimestamp;
  const feedbackStateSerialized = await storage.get(FEEDBACK_STATE);
  const feedbackState = parseProp<FeedbackState>(feedbackStateSerialized, isFeedbackState, {
    visitCounter: 0,
    lastVisitTime: 0,
    popupShown: false,
  });
  // reset state if request feedback time grater than last visit time
  if (feedbackState.lastVisitTime <= feedbackRequestTime) {
    feedbackState.popupShown = false;
    feedbackState.visitCounter = 0;
  }
  if (
    feedbackState.lastVisitTime >= feedbackRequestTime
    && feedbackState.visitCounter >= limit
    && feedbackState.popupShown === false
  ) {
    state.isFeedbackPopupVisible = true;
    feedbackState.popupShown = true;
  } else {
    feedbackState.visitCounter += 1;
  }
  feedbackState.lastVisitTime = currentTimestamp;
  await storage.set(FEEDBACK_STATE, JSON.stringify(feedbackState));
}
